import { render, staticRenderFns } from "./resetPassword.vue?vue&type=template&id=6ec00ebc"
import script from "./resetPassword.vue?vue&type=script&lang=js"
export * from "./resetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports